import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasResponsabilidadManejoVehiculoAtom, puntajeTotalResponsabilidadManejoVehiculoAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasResponsabilidadManejoVehiculo = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalResponsabilidadManejoVehiculoAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasResponsabilidadManejoVehiculoAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasResponsabilidadManejoVehiculo;
